import axios from 'axios'
import AscentiaService from './ascentiaService'
import Qs from 'qs'

const values = {
  analyticModules: null,
  analyticModule: null,
  analyticTrendsData: null,
  analyticComparisonData: null,
  features: null,
}

let allFeaturesByTailCall = null

const getters = {
  analyticModules(isAdmin) {
    if (isAdmin) {
      return axios.get(`/AnalyticModule?isAnalyticAdmin=true`)
    }
    return axios.get(`/AnalyticModule`)
  },
  analyticModule({ id }) {
    return axios.get(`/AnalyticModule/${id}`)
  },
  features() {
    return axios.get('/Feature')
  },
  ascentiaAnalyticsWithAlertTypes({ airlineIds, masterModelIds }) {
    const airlines = Qs.stringify(
      { airlines: airlineIds },
      { arrayFormat: 'repeat' },
    )
    const masterModels = Qs.stringify(
      { masterModelIds: masterModelIds },
      { arrayFormat: 'repeat' },
    )
    return axios.get(
      `/AnalyticModule/SimpleWithAlertTypes?${airlines}&${masterModels}`,
    )
  },

  customRecommendationEntry({ airlineId, analyticModuleId }) {
    return axios.get(
      `/AnalyticModule/customRecommendation?airlineId=${airlineId}&analyticModuleId=${analyticModuleId}`,
    )
  },

  analyticTrendsData(params) {
    if (params.startDate && params.endDate) {
      return axios.get(
        `/Feature/${params.featureId}/Data?tailNumber=${params.tailName}&startDate=${params.startDate}&endDate=${params.endDate}&isRiskScore=${params.isRiskScore}`,
      )
    }

    return axios.get(
      `/Feature/${params.featureId}/Data?tailNumber=${params.tailName}&isRiskScore=${params.isRiskScore}`,
    )
  },
  async analyticComparisonData(params) {
    const airlineIDs = Qs.stringify(
      { airlineIds: params.airlineIds },
      {
        arrayFormat: 'repeat',
      },
    )

    if (allFeaturesByTailCall) {
      allFeaturesByTailCall.cancel('Only one group request allowed at a time.')
    }

    allFeaturesByTailCall = axios.CancelToken.source()
    const list = params.features.map(feature => {
      const baseUrl = `/Feature/${feature.featureId}/Comparison?${airlineIDs}&startDate=${params.startDate}&endDate=${params.endDate}&isRiskScore=${feature.isRiskScore}`
      return axios.get(baseUrl, {
        cancelToken: allFeaturesByTailCall.token,
      })
    })
    const responses = await axios.all(list)
    const fleets = []
    const tails = []

    responses.forEach((resp, index) => {
      const riskScoreName = params.features[index]
        ? params.features[index].displayName
        : resp.data.cosmosFeatureKey
      resp.data.fleets.forEach(fleet => {
        const fleetItem = {
          ...fleet,
          tail: `${fleet.tail} ${riskScoreName}`,
        }
        fleets.push(fleetItem)
      })
      resp.data.tails.forEach(tail => {
        const tailItem = {
          ...tail,
          tail: `${tail.tail} ${riskScoreName}`,
        }
        tails.push(tailItem)
      })
    })

    const mergedData = {
      fleets,
      tails,
    }

    return mergedData
  },
}

const saves = {
  saveAnalyticModule(analyticModule) {
    const url = `/AnalyticModule/${analyticModule.id}`
    return axios.put(url, analyticModule)
  },

  saveCustomRecommendationEntry({
    airlineId,
    analyticModuleId,
    customEntries,
    platformName,
  }) {
    return axios.post('/AnalyticModule/customRecommendation', {
      airlineId: airlineId,
      analyticModuleId: analyticModuleId,
      recommendationText: customEntries,
      platformName: platformName,
    })
  },
}

export default class AnalyticModuleService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }
}
